import { TimeagoFormatter } from 'ngx-timeago';
export const MINUTE = 60;
export const HOUR = MINUTE * 60;
export const DAY = HOUR * 24;
export const WEEK = DAY * 7;
export const MONTH = DAY * 30;
export const YEAR = DAY * 365;
export type Unit = 'm' | 'h' | 'd' | 'w' | 'M' | 'Y';

export type Suffix = 'ago' | 'from now';

const customFormatter = (then: number): { value: number; unit: Unit } => {
  const now = Date.now();
  const seconds = Math.round(Math.abs(now - then) / 1000);
  const [value, unit]: [number, Unit] =
    seconds < MINUTE
      ? [0, 'm']
      : seconds < HOUR
      ? [Math.round(seconds / MINUTE), 'm']
      : seconds < DAY
      ? [Math.round(seconds / HOUR), 'h']
      : seconds < WEEK
      ? [Math.round(seconds / DAY), 'd']
      : seconds < MONTH
      ? [Math.round(seconds / WEEK), 'w']
      : seconds < YEAR
      ? [Math.round(seconds / MONTH), 'M']
      : [Math.round(seconds / YEAR), 'Y'];

  return { value, unit };
};

export class CustomFormatter extends TimeagoFormatter {
  format(then: number): string {
    const { value, unit } = customFormatter(then);
    return this.parse(value, unit);
  }

  private parse(value: number, unit: Unit): string {
    const prefix = !value ? '<' : '';
    const val = !value ? 1 : value;
    return prefix + val + unit;
  }
}
